"use client"

import DraggableContentList from "@/app/(site)/_components/DraggableContentList"
import { type RenderedItem } from "@/src/components/ContentMapper"

type DraftContentMapperProps = {
    items: RenderedItem[]
    documentId: string
    documentType: string
    contentField?: string
}

export default function DraftContentMapper({
    items,
    documentId,
    documentType,
    contentField = "content"
}: DraftContentMapperProps) {
    if (!items.length) return null

    return (
        <DraggableContentList
            documentId={documentId}
            documentType={documentType}
            contentField={contentField}
            items={items}
        />
    )
}
